// src/pages/Training.jsx
import React, { useState, useEffect, useRef } from 'react';
import { ChatAPI } from "../api/chatApi";

import * as Util from '../data/General';
const QUESTIONS  = [
  "Tiempo y proceso de entrega",
  "Costos de envío",
  "Seguimiento de pedidos",
  "Promociones y descuentos",
  "Medios de pago",
  "Proceso de devoluciones",
  "Cambios de productos",
  "Horarios de atención",
  "Facturación",
  "Garantía de productos",
];

const normalize = (text = "") =>
  text.toLowerCase().replace(/[¿?]/g, "").trim();

const QUESTION_MAP = QUESTIONS.reduce((acc, q) => {
  acc[normalize(q)] = q;
  return acc;
}, {});

export default function ConfigChat() {

  const store = Util.getAdminShop();
  const storeId = store.id;

  const [answers, setAnswers] = useState({});
  const [freeText, setFreeText] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // 🔹 CARGA INICIAL
  useEffect(() => {
    async function loadTraining() {
      try {
        const store = await ChatAPI.getStoreExamples(storeId);

        if (!store.training_examples) {
          setLoading(false);
          return;
        }

        const examples = JSON.parse(store.training_examples);

        const guided = {};
        let free = [];

        examples.forEach((ex) => {
          const normalizedUser = normalize(ex.user);
          const matchedQuestion = QUESTION_MAP[normalizedUser];

          if (matchedQuestion) {
            // 👉 Pregunta predefinida
            guided[matchedQuestion] = ex.assistant;
          } else {
            // 👉 Información libre
            free.push(ex.assistant);
          }
        });

        setAnswers(guided);
        setFreeText(free.join("\n\n"));
      } catch (e) {
        console.error("Error cargando entrenamiento", e);
      } finally {
        setLoading(false);
      }
    }

    loadTraining();
  }, [storeId]);

  // 🔹 GUARDAR
  const saveTraining = async () => {
    const examples = [];

    QUESTIONS.forEach((q) => {
      if (answers[q] && answers[q].trim()) {
        examples.push({
          user: `¿${q}?`,
          assistant: answers[q],
        });
      }
    });

    if (freeText.trim()) {
      examples.push({
        user: "Información general sobre la tienda",
        assistant: freeText,
      });
    }

    if (!examples.length) {
      alert("No hay información para guardar");
      return;
    }

    setSaving(true);
    await ChatAPI.saveExamples(storeId, examples);
    setSaving(false);

    alert("Entrenamiento guardado correctamente");
  };

  if (loading) {
    return <p>Cargando entrenamiento…</p>;
  }

  return (
    <div className="training-container">
      <h1>Entrená a Lia</h1>

      <p className="training-intro">
        Completá estas respuestas como si fueras tu tienda.
        Lia usará esta información para responder automáticamente.
      </p>

      <div className="training-grid">
        {/* IZQUIERDA */}
        <div>
          <h3>Preguntas frecuentes</h3>

          {QUESTIONS.map((q) => (
            <div key={q} className="training-block">
              <label>{q}</label>
              <textarea
                rows={3}
                value={answers[q] || ""}
                placeholder="Escribí la respuesta que daría tu tienda"
                onChange={(e) =>
                  setAnswers({ ...answers, [q]: e.target.value })
                }
              />
            </div>
          ))}
        </div>

        {/* DERECHA */}
        <div className="training-block">
          <h3>Información adicional</h3>
          <p className="hint">
            Detalles generales, tono de marca, aclaraciones, etc.
          </p>

          <textarea
            rows={18}
            value={freeText}
            placeholder="Ej: Somos una tienda familiar, respondemos de forma cercana…"
            onChange={(e) => setFreeText(e.target.value)}
          />
        </div>
      </div>

      <button
        className="save-btn"
        onClick={saveTraining}
        disabled={saving}
      >
        {saving ? "Guardando…" : "Guardar entrenamiento"}
      </button>
    </div>
  );
}